import config from '@/config/index'
const titles = config.isYp ? '邀朋互娱' : '闲逸互娱';
const routers = [
  {
    path: '/receipt',
    name: 'receipt',
    component: () => import(/* webpackChunkName: "act" */ '@/views/Index/receipt'),
    meta: { title: '小票', keepAlive: false }
  },
  {
    path: '/buy',
    name: 'buy',
    component: () => import(/* webpackChunkName: "act" */ '@/views/Index/buy'),
    meta: { title: titles, keepAlive: false }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: "act" */ '@/views/Index/detail'),
    meta: { title: titles, keepAlive: false }
  }
]

export default routers
